var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItalicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81992 6.75H10.3199L8.66992 14.25H7.16992L8.81992 6.75ZM10.0799 3.75C9.93159 3.75 9.78658 3.79399 9.66324 3.8764C9.53991 3.95881 9.44378 4.07594 9.38701 4.21299C9.33025 4.35003 9.31539 4.50083 9.34433 4.64632C9.37327 4.7918 9.4447 4.92544 9.54959 5.03033C9.65448 5.13522 9.78812 5.20665 9.9336 5.23559C10.0791 5.26453 10.2299 5.24968 10.3669 5.19291C10.504 5.13614 10.6211 5.04001 10.7035 4.91668C10.7859 4.79334 10.8299 4.64834 10.8299 4.5C10.8299 4.30109 10.7509 4.11032 10.6103 3.96967C10.4696 3.82902 10.2788 3.75 10.0799 3.75Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalicIcon);
export default __webpack_public_path__ + "static/media/italicIcon.663ca1fb3691cc1f17de2b7b18229ac5.svg";
export { ForwardRef as ReactComponent };